/* eslint-disable no-param-reassign  */
import { createSlice } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import MyBundleRepository from 'repositories/buyer/MyBundleRepository';

const initialState = {
  myBundle: {},
  loading: false,
};

const myBundleSlice = createSlice({
  name: 'myBundleSlice',
  initialState,
  reducers: {
    loadMyBundleStart(state) {
      state.loading = true;
    },
    loadMyBundleSuccess(state, { payload }) {
      state.myBundle = payload.attributes;
      state.loading = false;
    },
    loadMyBundleFail(state) {
      state.loading = false;
    },
    updateMyBundleStart(state) {
      state.loading = true;
    },
    updateMyBundleFinish(state) {
      state.loading = false;
    },
  },
});

export const { actions } = myBundleSlice;

export default myBundleSlice.reducer;

export const useAppActions = () => {
  const dispatch = useDispatch();

  const loadMyBundle = async () => {
    dispatch(actions.loadMyBundleStart());
    try {
      const { data } = await MyBundleRepository.show();
      dispatch(actions.loadMyBundleSuccess(data));
      return data;
    } catch (error) {
      dispatch(actions.loadMyBundleFail());
      return Promise.reject(error);
    }
  };

  const updateMyBundle = async attrs => {
    dispatch(actions.updateMyBundleStart());
    try {
      await MyBundleRepository.update(attrs);
    } finally {
      dispatch(actions.updateMyBundleFinish());
    }
  };

  return {
    loadMyBundle,
    updateMyBundle,
  };
};
/* eslint-enable no-param-reassign */



// WEBPACK FOOTER //
// ./src/reducers/slices/myBundleSlice.js